var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useState } from "react";
import { useTranslate } from "react-admin";
import { Box, Button, ButtonGroup, Divider, Grid, Typography } from "@mui/material";
import HistoryIcon from "@mui/icons-material/History";
import SettingsOutlinedIcon from "@mui/icons-material/SettingsOutlined";
import { BODY_GRID_PADDING } from "../styles/styleConstants.data";
import { general } from "../utils/componentWizard";
import BatchHistory from "./BatchHistory";
import BatchOperation from "./BatchOperation";
import { useRemainingQuota } from "./useRemainingQuota";
var OPERATION_STAGES = ["upload", "preview", "generate"];
var BulkGeneration = function () {
    var translate = useTranslate();
    var _a = useRemainingQuota(), remainingQuota = _a.remainingQuota, quotaLoading = _a.loading, refreshQuota = _a.refreshQuota;
    var _b = useState("operation"), section = _b[0], setSection = _b[1];
    var _c = useState(false), historyOpened = _c[0], setHistoryOpened = _c[1];
    var _d = useState(0), panelRefreshKey = _d[0], setPanelRefreshKey = _d[1];
    var _e = useState(0), operationStage = _e[0], setOperationStage = _e[1];
    var _f = useState(null), resumedBatch = _f[0], setResumedBatch = _f[1];
    var _g = useState(null), resumedReportJob = _g[0], setResumedReportJob = _g[1];
    var continueInOperation = function (batch, reportJob) {
        setResumedBatch(batch);
        setResumedReportJob(reportJob);
        setOperationStage(2);
        setPanelRefreshKey(function (value) { return value + 1; });
        setSection("operation");
    };
    var switchSection = function (next) {
        if (next === section)
            return;
        setSection(next);
        if (next === "history") {
            setHistoryOpened(true);
        }
        setPanelRefreshKey(function (value) { return value + 1; });
        void refreshQuota();
    };
    var breadcrumbTrail = __spreadArray([
        translate("breadcrumb.main"),
        translate("pages.bulkGeneration.name")
    ], (section === "history"
        ? [translate("pages.bulkGeneration.history.title")]
        : [translate("pages.bulkGeneration.stages.".concat(OPERATION_STAGES[operationStage]))]), true);
    return (_jsxs(Grid, { container: true, padding: BODY_GRID_PADDING, spacing: 2, children: [_jsx(Grid, { item: true, xs: 12, children: _jsx(general.breadcrumb, { trail: breadcrumbTrail }) }), _jsx(Grid, { item: true, xs: 12, children: _jsxs(Box, { display: "flex", alignItems: "center", justifyContent: "space-between", gap: 2, flexWrap: "wrap", children: [_jsx(Typography, { className: "normal-text large-bold", children: translate("pages.bulkGeneration.name") }), _jsxs(ButtonGroup, { size: "small", "aria-label": translate("pages.bulkGeneration.name"), children: [_jsx(Button, { variant: section === "operation" ? "contained" : "outlined", startIcon: _jsx(SettingsOutlinedIcon, {}), onClick: function () { return switchSection("operation"); }, children: translate("pages.bulkGeneration.sections.operation") }), _jsx(Button, { variant: section === "history" ? "contained" : "outlined", startIcon: _jsx(HistoryIcon, {}), onClick: function () { return switchSection("history"); }, children: translate("pages.bulkGeneration.sections.history") })] })] }) }), _jsx(Grid, { item: true, xs: 12, children: _jsx(Divider, {}) }), _jsxs(Grid, { item: true, xs: 12, children: [_jsx(Box, { display: section === "operation" ? "block" : "none", children: _jsx(BatchOperation, { isActive: section === "operation", refreshKey: panelRefreshKey, onActiveStageChange: setOperationStage, resumedBatch: resumedBatch, resumedReportJob: resumedReportJob, onQuotaChange: refreshQuota, remainingQuota: remainingQuota, quotaLoading: quotaLoading }) }), historyOpened && (_jsx(Box, { display: section === "history" ? "block" : "none", children: _jsx(BatchHistory, { isActive: section === "history", refreshKey: panelRefreshKey, onContinueOperation: continueInOperation, onQuotaChange: refreshQuota, remainingQuota: remainingQuota, quotaLoading: quotaLoading }) }))] })] }));
};
export default BulkGeneration;
